
const fg_no_states = [ 'AK', 'HI', 'MS', 'RI', 'SD', 'UT' ];

const fg_wh_states = {
    "ETC": [ 'AL','AK','GA','IL','ID','IA','KS','KY','LA','MI','MN','MS','MO','NE','ND','OH','OK','SD','TN','TX','WV','WI' ],
    "COB": [ 'CT','DE','DC','FL','ME','MD','MA','NH','NJ','NY','NC','PA','RI','SC','VT','VA' ],
    "VCX": [ 'AZ','CA','CO','HI','ID','MT','NV','NM','OR','UT','WA','WY' ]
}

const FREQUENCY_MS = 1000 * 60 * 60 * 24;

// If the user selected a state, set the current WH
var fg_wh = '';

function setCurrentWarehouse() {
    const currentState = window.localStorage.getItem('fgw_state');
    if (currentState) {
        // in entries: 0 is key, 1 is value
        const entryForState = Object.entries(fg_wh_states).find((anEntry) => anEntry[1].includes(currentState));
        if (entryForState) {
            fg_wh = entryForState[0];
        } else {
            fg_wh = '';
        }
    }
}

function enableAvailabilityElements() {
    const availabilityElements = document.querySelectorAll('[data-fg-availability-element]');
    availabilityElements.forEach((element) => {
        element.removeAttribute('disabled');
        element.classList.remove('disabled');
    });

    // hide all "item cannot ship to your state" elements
    document.querySelectorAll('[data-unavailable-state]').forEach((el) => {
        el.setAttribute('hidden', true);
        const thingToDisable = el.closest('[data-unavailable-disable]');
        const thingToCover = el.parentElement.querySelector('[data-unavailable-cover]');
        if (thingToDisable) thingToDisable.classList.remove('unavail_disable');
        if (thingToCover) thingToCover.classList.remove('unavail_cover');
    });

}

function disableElements(elements) {
    for(const anElement of elements) {
        const availabilityContainer = anElement.closest('[data-unavailable-disable]');
        const availabilityElements = availabilityContainer.querySelectorAll('[data-fg-availability-element]');
        availabilityElements.forEach((element) => {
            element.setAttribute('disabled', '');
            element.classList.add('disabled');
        });
    }
}

function showUnavailable(elements) {
    for(const anElement of elements) {
        const availabilityContainer = anElement.closest('[data-unavailable-disable]');
            //console.log(`availabilityContainer: ${availabilityContainer}`);
        if (availabilityContainer) {
            const el = availabilityContainer.querySelector('[data-unavailable-state]');
            if (el) {
                el.removeAttribute('hidden');
            }
            const thingToCover = availabilityContainer.querySelector('[data-unavailable-cover]');
            //console.log(`thingToCover: ${thingToCover}`);
            if (availabilityContainer) availabilityContainer.classList.add('unavail_disable');
            if (thingToCover) thingToCover.classList.add('unavail_cover');
        } else {
            console.error('data-unavailable-disable container not found, availability checks will not work');
        }
    }
}
function fgCheckAvailability() {
    enableAvailabilityElements();
    let unavailableByState = [];
    let unavailableByWh= [];

    // disable based on selected state (compliance)
    if (fgCurrentState()) {
        const states = document.querySelectorAll('[data-fg-states]');
        var i = 0;
        for (var anElement of states) {
            testDisable = window.fgAvailabilityTesting === true;
            if ((testDisable && i == 0) || (!anElement.dataset.fgStates || !anElement.dataset.fgStates.includes(fgCurrentState()))) {
                unavailableByState.push(anElement);
            }
            i++;
        }
        // show "Item unavailable in your state" elements
        console.log(`Disabling ${unavailableByState.length} wines not available in state ${fgCurrentState()}`);
        disableElements(unavailableByState);
        showUnavailable(unavailableByState);
    }

    // disable based on WH (sold out)
    const whs = document.querySelectorAll('[data-fg-oos-wh]');
    for (var anElement of whs) {
        let list = anElement.dataset.fgOosWh;
        if (fgCurrentWarehouse() && list.indexOf(fgCurrentWarehouse()) >= 0) {
            unavailableByWh.push(anElement);
        }
    }
    console.log(`Disabling ${unavailableByWh.length} wines Out of Stock in wh ${fgCurrentWarehouse()}`);
    disableElements(unavailableByWh);
    showUnavailable(unavailableByWh);
}

function fgCurrentWarehouse() {
    return fg_wh ? fg_wh.toLowerCase() : '';
}

function fgCurrentState() {
    return localStorage.getItem('fgw_state');
}

function showError(dialogElement, message) {
    const er = dialogElement.querySelector('.error');
    if (er) {
        er.innerHTML = message;
        er.classList.remove('hidden');
        er.removeAttribute('hidden');
    }
}

document.addEventListener('DOMContentLoaded', () => {

    // check if we have to display the dialog in the first place
    var popAgeDialog = false;
    const ageCheckKey = `fgAgeCheck-${Shopify.shop}`;
    const ageLastChecked = localStorage.getItem(ageCheckKey);

    if (ageLastChecked) {
        const ageCheckedDate = new Date(ageLastChecked);

        // if we didn't get a valid date, or the date we got is > FREQUENCY_MS, pop dialog
        if (!ageCheckedDate || (ageCheckedDate && (Date.now() - ageLastChecked > FREQUENCY_MS))) {
            popAgeDialog = true;
        }
    } else {
        popAgeDialog = true;
    }
    
    if (popAgeDialog) {
        const overlay = document.querySelector('.fg-modal-overlay');
        if (overlay) {
            document.body.classList.add('modal_open');
        }
    }

    // button handlers for dialog if needed
    const dialog = document.querySelector('.fg-modal-state');
    if (dialog) {
        dialog.querySelector('#fg-age-confirm').addEventListener('click', (event) => {
            event.preventDefault();
            const stateSelector = dialog.querySelector('.fgw_state_select');
            const stateSelected = stateSelector.value;
            if (!stateSelected) {
                showError(dialog, "You must select a state");
            } else {
                window.localStorage.setItem(ageCheckKey, JSON.stringify(new Date()));
                window.localStorage.setItem('fgw_state', stateSelected);
                document.dispatchEvent(new CustomEvent('fgw_state_change'));
                document.body.classList.remove('modal_open');
            }
        });
        dialog.querySelector('#fg-age-decline').addEventListener('click', (event) => {
            event.preventDefault();
            showError(dialog, 'You must be over 21 or older to enter');
        });
    }

    // state selector event dispatch
    const stateSelects = document.querySelectorAll('select.fgw_state_select');
    if (localStorage.getItem('fgw_state')) {
        stateSelects.forEach((ss) => ss.value = localStorage.getItem('fgw_state'));
    }
    stateSelects.forEach((ss) => ss.addEventListener('change', (event) => {
        const stateSelected = event.target.value;
        window.localStorage.setItem('fgw_state', stateSelected);
        document.dispatchEvent(new CustomEvent('fgw_state_change', { 'new_state': stateSelected }));
    }));

    // handle change state event
    document.addEventListener('fgw_state_change', (event) => {
        const stateSelected = window.localStorage.getItem('fgw_state');
        const stateSelects  = document.querySelectorAll('select.fgw_state_select');
        if (stateSelects && stateSelected) {
            stateSelects.forEach((ss) => ss.value = stateSelected);
        }
        setCurrentWarehouse();
        fgCheckAvailability();
    });

    // handle rebuy load event
    document.addEventListener('rebuy.ready', (event) => fgCheckAvailability());

    setCurrentWarehouse();
    fgCheckAvailability();
});

